import { default as ProfilePage } from './Profile';

export { default as Avatar } from './Avatar';

export default ProfilePage;
